import {ButtonGroup, IconButton, Stack} from "@mui/material";
import {ArrowDownward, ArrowUpward} from "@mui/icons-material";

export default function OrderCartArrows({onMoveUp, onMoveDown}) {
    return (
        <ButtonGroup component={Stack} direction={'column'}>

            <IconButton onClick={onMoveUp}>
                <ArrowUpward/>
            </IconButton>

            <IconButton onClick={onMoveDown}>
                <ArrowDownward/>
            </IconButton>

        </ButtonGroup>
    )
}